import DataWebService from "service/web/DataWebService";
import {binaryStore} from "stores/BinaryStore";
import {commentsStore} from "stores/CommentsStore";
import {contractStore} from "stores/ContractStore";
import {dataItemStore} from "stores/DataItemStore";
import {modalsStore} from "stores/ModalsStore";
import {partyStore} from "stores/PartyStore";
import {userStore} from "stores/UserStore";
import {viewportStore} from "stores/ViewportStore";
import {workflowStore} from "stores/WorkflowStore";

const initialiseStores = async () => {
    const data = await DataWebService.getDataAsync();
    if (!data) return;
    commentsStore.initialise(data.comments)
    dataItemStore.initialise(data.dataItems);
    partyStore.initialise(data.appUsers, data.contacts, data.companies);
    userStore.initialise(data.authUser);
    workflowStore.initialise(data.workflowTemplates, data.workflows, data.nodes);

    const binaryData = await DataWebService.getBinaryDataAsync();
    if (!binaryData) return;
    binaryStore.initialise(binaryData.binaryDataMap);
};

export {
    initialiseStores, binaryStore, contractStore, dataItemStore, modalsStore, partyStore, userStore, viewportStore,
    workflowStore, commentsStore
}